import {Scene, WebGLRenderer, Camera, Vector3, PerspectiveCamera} from 'three';

export class PhotoGenerator
{
	private static _canvas: HTMLCanvasElement = document.createElement('canvas');
	private static _context: WebGLRenderingContext = (PhotoGenerator._canvas.getContext('webgl2') || PhotoGenerator._canvas.getContext('experimental-webgl2')) as WebGLRenderingContext;
	private static _renderer: WebGLRenderer;
	private _scene: Scene;
	private _camera: Camera;
	private _resolution = {
		x: 1024,
		y: 768
	};

	constructor(scene: Scene, width?: number, height?: number)
	{
		this._scene = scene;
		if (width)
		{
			this._resolution.x = width;
		}
		if (height)
		{
			this._resolution.y = height;
		}
		this._camera = new PerspectiveCamera(60, this._resolution.x / this._resolution.y, 1, 1000);

		PhotoGenerator._renderer = PhotoGenerator._renderer || new WebGLRenderer({
			antialias: true,
			context: PhotoGenerator._context,
			canvas: PhotoGenerator._canvas,
		});
		//PhotoGenerator._renderer.useLegacyLights = true;

		PhotoGenerator._renderer.setSize(this._resolution.x, this._resolution.y);
	}

	public setCameraPosition(cameraPosition: Vector3)
	{
		this._camera.position.copy(cameraPosition);
	}

	public setCameraTarget(cameraTarget: Vector3)
	{
		this._camera.lookAt(cameraTarget);
	}

	public getPhoto()
	{
		PhotoGenerator._renderer.render(this._scene, this._camera);
		const dataURL = PhotoGenerator._canvas.toDataURL('image/jpeg', 0.75);

		return dataURL;
	}

	public get resolution()
	{
		return this._resolution;
	}
}
